import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend-v3/src/components/gallery/index.tsx");
